module.exports = __webpack_public_path__ + "static/img/banner-pt.d271a52.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner-pt.png
// module id = QxaK
// module chunks = 1